
import { computed, defineComponent } from 'vue'

export default defineComponent({
    name: 'TGSelect',
    props: {
        modelValue: {
            type: String,
            required: false,
            default: ''
        },
        options: {
            type: Array as () => ({ description: string; value: string }[]),
            required: true
        }
    },
    emits: ['update:modelValue'],
    setup (props, { emit }) {
        const value = computed({
            get () {
                return props.modelValue
            },
            set (value) {
                emit('update:modelValue', value)
            }
        })

        return { value }
    }
})
